import ExportWorkflow from '../../../../components/workflows/general/export-workflow';

angular
    .module('festzelt-os.billing.invoices')
    .factory('exportInvoices', [
        'Alert',
        '$http',
        '$uibModal',
        '$translate',
        (Alert, $http, $uibModal, $translate) => new ExportWorkflow('invoices', Alert, $http, $uibModal, $translate,{
            'csv': 'CSV',
            'excel': 'Excel',
            'invoice_pdfs': 'PDFs'
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/workflows/export-invoices.js